import { render, staticRenderFns } from "./ReportBE.vue?vue&type=template&id=5b3d9d96&"
import script from "./ReportBE.vue?vue&type=script&lang=js&"
export * from "./ReportBE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports